/* src/app/app.component.css */
.toolbar-spacer {
  flex: 1 1 auto;
}
a.title {
  color: white;
}
/*# sourceMappingURL=app.component-WBHXYVSB.css.map */
